import { defineStore } from 'pinia'

// Exemplo de configuração básica do Pinia, biblioteca de gerenciamento de estado que o VueJs dá suporte
export const authStore = defineStore('auth', {
  state: () => {
    return {
      logged: false,
      user: {
        name: 'lorem Ipsum',
        email: 'lorem@gmail.com',
        plan: 'Plano Basico',
        isAdmin: false
      }
    }
  },
  getters: {
    userName (state) {
      return state.user.cas_user
    },
    userInfo (state) {
      return {
        name: state.user.name,
        additionalInfo: state.user.cas_user
      }
    }
  },
  actions: {
    login (user) {
      this.logged = true
      this.user = user
    }
  }
})
